module.exports = __webpack_public_path__ + "img/Come, Come to the Sunset Tree.03536174.jpg";